// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { getUsers, updateUser } from '../services/api';

// const UpdateUser = () => {
//   const { id } = useParams();
//   const [formData, setFormData] = useState({
//     username: '',
//     email: '',
//     password: '',
//     role: 'employee',
//     employee_name: '',
//     employee_code: '',
//   });
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const role = localStorage.getItem('role');
//   const user_id = parseInt(localStorage.getItem('user_id'));

//   useEffect(() => {
//     if (role !== 'super_admin' && parseInt(id) !== user_id) {
//       navigate('/dashboard');
//       return;
//     }

//     getUsers()
//       .then(res => {
//         if (res.data.error) {
//           setError(res.data.error);
//           setLoading(false);
//           navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
//         } else {
//           // ✅ Fix: access res.data.data instead of res.data
//           const user = Array.isArray(res.data.data) ? res.data.data.find(u => u.id === parseInt(id)) : null;
//           if (user) {
//             setFormData({
//               username: user.username || '',
//               email: user.email || '',
//               password: '',
//               role: user.role || 'employee',
//               employee_name: user.employee_name || '',
//               employee_code: user.employee_code || '',
//             });
//             setLoading(false);
//           } else {
//             setError('User not found');
//             setLoading(false);
//             navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
//           }
//         }
//       })
//       .catch(err => {
//         console.error('Error fetching user:', err);
//         setError(err.response?.data?.error || 'Failed to fetch user');
//         setLoading(false);
//         navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
//       });
//   }, [id, navigate, role, user_id]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);

//     const dataToSubmit = {};
//     if (formData.username) dataToSubmit.username = formData.username;
//     if (formData.email) dataToSubmit.email = formData.email;
//     if (formData.password) dataToSubmit.password = formData.password;
//     if (role === 'super_admin' && formData.role) dataToSubmit.role = formData.role;
//     if (formData.employee_name) dataToSubmit.employee_name = formData.employee_name;
//     if (formData.employee_code) dataToSubmit.employee_code = formData.employee_code;

//     if (Object.keys(dataToSubmit).length === 0) {
//       setError('At least one field must be provided');
//       return;
//     }

//     try {
//       const response = await updateUser(id, dataToSubmit);
//       if (response.data.success) {
//         alert('User updated successfully');
//         if (parseInt(id) === user_id) {
//           localStorage.setItem('username', formData.username || localStorage.getItem('username'));
//           localStorage.setItem('email', formData.email || localStorage.getItem('email'));
//           if (formData.role) localStorage.setItem('role', formData.role);
//         }
//         navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
//       } else {
//         setError(response.data.error || 'Failed to update user');
//       }
//     } catch (err) {
//       console.error('Error updating user:', err);
//       setError(err.response?.data?.error || 'Failed to update user');
//     }
//   };

//   if (loading) {
//     return <div className="p-6 text-gray-600">Loading...</div>;
//   }

//   return (
//     <div className="p-6 bg-white rounded-xl shadow-md max-w-md mx-auto mt-4">
//       <h3 className="text-xl font-semibold text-gray-800 mb-4">Update User</h3>
//       {error && <p className="text-red-600 mb-4">{error}</p>}
//       <form onSubmit={handleSubmit} className="space-y-6">
//         <div>
//           <label className="block text-gray-700 font-medium mb-2">Username</label>
//           <input
//             type="text"
//             name="username"
//             value={formData.username}
//             onChange={handleChange}
//             className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//           />
//         </div>

//         <div>
//           <label className="block text-gray-700 font-medium mb-2">Email</label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//           />
//         </div>

//         <div>
//           <label className="block text-gray-700 font-medium mb-2">New Password (optional)</label>
//           <input
//             type="password"
//             name="password"
//             value={formData.password}
//             onChange={handleChange}
//             className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//             placeholder="Leave blank to keep unchanged"
//           />
//         </div>

//         {role === 'super_admin' && (
//           <div>
//             <label className="block text-gray-700 font-medium mb-2">Role</label>
//             <select
//               name="role"
//               value={formData.role}
//               onChange={handleChange}
//               className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//             >
//               <option value="employee">Employee</option>
//               <option value="manager">Manager</option>
//               <option value="functional_admin">Functional Admin</option>
//               <option value="super_admin">Super Admin</option>
//             </select>
//           </div>
//         )}

//         <div>
//           <label className="block text-gray-700 font-medium mb-2">Employee Name</label>
//           <input
//             type="text"
//             name="employee_name"
//             value={formData.employee_name}
//             onChange={handleChange}
//             className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//           />
//         </div>

//         <div>
//           <label className="block text-gray-700 font-medium mb-2">Employee Code</label>
//           <input
//             type="text"
//             name="employee_code"
//             value={formData.employee_code}
//             onChange={handleChange}
//             className="w-full p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500"
//           />
//         </div>

//         <button
//           type="submit"
//           className="bg-green-500 text-white px-6 py-3 rounded-md hover:bg-green-600 w-full"
//         >
//           Update User
//         </button>
//       </form>
//     </div>
//   );
// };

// export default UpdateUser;
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUsers, updateUser } from '../services/api';

const UpdateUser = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({ username: '', email: '', password: '', role: 'employee', employee_name: '', employee_code: '' });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const role = localStorage.getItem('role');
  const user_id = parseInt(localStorage.getItem('user_id'));

  useEffect(() => {
    if (role !== 'super_admin' && parseInt(id) !== user_id) { navigate('/dashboard'); return; }
    getUsers()
      .then(res => {
        if (res.data.error) {
          setError(res.data.error);
          setLoading(false);
          navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
        } else {
          const user = Array.isArray(res.data.data) ? res.data.data.find(u => u.id === parseInt(id)) : null;
          if (user) {
            setFormData({ username: user.username || '', email: user.email || '', password: '', role: user.role || 'employee', employee_name: user.employee_name || '', employee_code: user.employee_code || '' });
            setLoading(false);
          } else {
            setError('User not found');
            setLoading(false);
            navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
          }
        }
      })
      .catch(err => {
        setError(err.response?.data?.error || 'Failed to fetch user');
        setLoading(false);
        navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
      });
  }, [id, navigate, role, user_id]);

  const handleChange = (e) => { const { name, value } = e.target; setFormData({ ...formData, [name]: value }); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const dataToSubmit = {};
    if (formData.username) dataToSubmit.username = formData.username;
    if (formData.email) dataToSubmit.email = formData.email;
    if (formData.password) dataToSubmit.password = formData.password;
    if (role === 'super_admin' && formData.role) dataToSubmit.role = formData.role;
    if (formData.employee_name) dataToSubmit.employee_name = formData.employee_name;
    if (formData.employee_code) dataToSubmit.employee_code = formData.employee_code;
    if (Object.keys(dataToSubmit).length === 0) { setError('At least one field must be provided'); return; }
    try {
      const response = await updateUser(id, dataToSubmit);
      if (response.data.success) {
        alert('User updated successfully');
        if (parseInt(id) === user_id) {
          localStorage.setItem('username', formData.username || localStorage.getItem('username'));
          localStorage.setItem('email', formData.email || localStorage.getItem('email'));
          if (formData.role) localStorage.setItem('role', formData.role);
        }
        navigate(role === 'super_admin' ? '/dashboard/users' : '/dashboard');
      } else {
        setError(response.data.error || 'Failed to update user');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update user');
    }
  };

  if (loading) return <div className="p-6 text-gray-600">Loading...</div>;

  return (
    <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
      <div className="bg-white rounded-xl shadow-md p-5 sm:p-6 max-w-md mx-auto mt-2 sm:mt-4">
        <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">Update User</h3>
        {error && <p className="text-red-600 mb-4 text-sm">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5">
          {[
            { label: 'Username', name: 'username', type: 'text' },
            { label: 'Email', name: 'email', type: 'email' },
          ].map(({ label, name, type }) => (
            <div key={name}>
              <label className="block text-gray-700 font-medium mb-1 sm:mb-2 text-sm sm:text-base">{label}</label>
              <input type={type} name={name} value={formData[name]} onChange={handleChange}
                className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base" />
            </div>
          ))}
          <div>
            <label className="block text-gray-700 font-medium mb-1 sm:mb-2 text-sm sm:text-base">New Password (optional)</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange}
              className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base"
              placeholder="Leave blank to keep unchanged" />
          </div>
          {role === 'super_admin' && (
            <div>
              <label className="block text-gray-700 font-medium mb-1 sm:mb-2 text-sm sm:text-base">Role</label>
              <select name="role" value={formData.role} onChange={handleChange}
                className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base">
                <option value="employee">Employee</option>
                <option value="manager">Manager</option>
                <option value="functional_admin">Functional Admin</option>
                <option value="super_admin">Super Admin</option>
              </select>
            </div>
          )}
          {[
            { label: 'Employee Name', name: 'employee_name', type: 'text' },
            { label: 'Employee Code', name: 'employee_code', type: 'text' },
          ].map(({ label, name, type }) => (
            <div key={name}>
              <label className="block text-gray-700 font-medium mb-1 sm:mb-2 text-sm sm:text-base">{label}</label>
              <input type={type} name={name} value={formData[name]} onChange={handleChange}
                className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-md focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 text-sm sm:text-base" />
            </div>
          ))}
          <button type="submit" className="bg-green-500 text-white px-6 py-2.5 sm:py-3 rounded-md hover:bg-green-600 w-full text-sm sm:text-base font-medium">
            Update User
          </button>
        </form>
      </div>
    </div>
  );
};

export default UpdateUser;